const validateCreateProgram = ({ image, linkToApply, description, title, isUpdate }) => {
  const errors = {}

  if (!image && !isUpdate) {
    errors.image = 'Please upload an image.'
  }

  // For new programs, a link is required so they appear as "current".
  // For updates, the link can be cleared (making the program a "past" program).
  if (!linkToApply?.trim() && !isUpdate) {
    errors.linkToApply = 'Please enter a link to apply.'
  }

  // If a link is provided, it must be a valid http(s) URL.
  if (linkToApply && !/^(http|https):\/\/[^ "]+$/.test(linkToApply)) {
    errors.linkToApply = 'Please enter a valid link.'
  }

  if (!description?.trim()) {
    errors.description = 'Please enter a description.'
  }

  if (!title?.trim()) {
    errors.title = 'Please enter a title.'
  }

  const hasErrors = errors.image || errors.linkToApply || errors.description || errors.title

  return { errors, hasErrors }
}

export default validateCreateProgram
